import React from 'react'

const cta = () => {
  return (
    <div className='CTA'>
        <a href="https://ahmedghaith.com/ahmed-mohamed-resume.pdf"    target="_blank" className='btn'> Downland CV</a>
        <a href="#contact" className='btn btn_primary'>Lets Talk</a>
        
    </div>
  )
}

export default cta